import { Navigate, useLocation } from 'react-router-dom';

export const LegacyLoginRedirect = () => {
  const location = useLocation();

  // Router-relative navigation applies the basename once and retains fragments,
  // which are not available on a loader's Request URL.
  return (
    <Navigate
      replace
      to={{ pathname: '/login', search: location.search, hash: location.hash }}
      state={location.state}
    />
  );
};
